"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const TabularController_1 = __importDefault(require("@becrop/components/Farms/Abstract/Controllers/TabularController"));
const TabPillsSet_vue_1 = __importDefault(require("@becrop/components/Farms/TabPillsSet.vue"));
const TabPillsSetItem_vue_1 = __importDefault(require("@becrop/components/Farms/TabPillsSetItem.vue"));
const FieldsTable_vue_1 = __importDefault(require("@becrop/components/Farms/FieldsTable.vue"));
const SamplesTable_vue_1 = __importDefault(require("@becrop/components/Farms/SamplesTable.vue"));
let FarmsView = class FarmsView extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.CONTROLLER = TabularController_1.default.getInstance();
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get scope() {
        return this.CONTROLLER.scope;
    }
    mounted() {
        if (!this.hasfields)
            this.CONTROLLER.scope = 'samples';
    }
    setActive(s) {
        this.CONTROLLER.scope = s;
    }
    get loading() {
        return this.CONTROLLER.loading;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'light' })
], FarmsView.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], FarmsView.prototype, "hasfields", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], FarmsView.prototype, "hassamples", void 0);
FarmsView = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Yield: bmk_ui_framework_1.Yield,
            Breadcrumbs: bmk_ui_framework_1.Breadcrumbs,
            BreadcrumbsItem: bmk_ui_framework_1.BreadcrumbsItem,
            HomeIcon: bmk_ui_framework_1.HomeIcon,
            PageHeading: bmk_ui_framework_1.PageHeading,
            ProposalsIcon: bmk_ui_framework_1.ProposalsIcon,
            Separator: bmk_ui_framework_1.Separator,
            TabPillsSet: TabPillsSet_vue_1.default,
            TabPillsSetItem: TabPillsSetItem_vue_1.default,
            FieldsTable: FieldsTable_vue_1.default,
            SamplesTable: SamplesTable_vue_1.default,
        },
    })
], FarmsView);
exports.default = FarmsView;
